export interface CommissionTemplateTier {
  thresholdStart: number
  thresholdEnd: number
  contractRatePercentage: number
  permRatePercentage: number
}

export interface ContributorCommissionRateTier {
  ytdThresholdStart: number
  ytdThresholdEnd: number
  contractRatePercentage: number
  permRatePercentage: number
}

export interface CommissionRateTemplateApprovalDto {
  id?: number
  name: string
  contributionPeriodId: number
  isAssignable: boolean
  commissionTemplateTiers: CommissionTemplateTier[]
}

export interface ContributorCommissionRatePlanApprovalDto {
  name: string
  contributorId: number
  templateId: number
  templateName: string
  effectiveDate: string | null
  commissionTemplateTiers: CommissionTemplateTier[]
}

export interface ContributorCommissionRatePlanUpdateDto {
  id?: number
  name: string
  contributorId: number
  templateId: number
  templateName: string
  effectiveDate: string | null
  commissionRates: ContributorCommissionRateTier[]
}

export interface LegacyCommissionRateFields {
  contractRatePercentage?: number | null
  permRatePercentage?: number | null
  commissionRatePercentage?: number | null
  ratePercentage?: number | null
}

export interface DualCommissionRates {
  contractRatePercentage: number | null
  permRatePercentage: number | null
}

export function resolveDualCommissionRates(tier: LegacyCommissionRateFields): DualCommissionRates {
  const fallbackRate =
    tier.contractRatePercentage ??
    tier.permRatePercentage ??
    tier.commissionRatePercentage ??
    tier.ratePercentage ??
    null
  const contractRatePercentage = tier.contractRatePercentage ?? fallbackRate
  const permRatePercentage = tier.permRatePercentage ?? fallbackRate

  return {
    contractRatePercentage,
    permRatePercentage,
  }
}
